import { CountryFlag } from 'shared/src/CountryFlag';

import { getCountryName } from 'utils/formatters/getCountryName';
import { hasValue } from 'utils/hasValue';

export function Country({
  countryIso
}: {
  countryIso: string | undefined | null;
}) {
  if (!hasValue(countryIso)) {
    return 'N/A';
  }
  return (
    <div className="flex flex-row items-center gap-2">
      <CountryFlag className="!size-[22px]" countryCode={countryIso} svg />
      {getCountryName(countryIso)}
    </div>
  );
}
